<template>
  <div style="max-width: 300px" class="mx-auto mt-4">
    <card>
      <h4 class="card-title text-center">Dashboard APP SoluCX</h4>
      <form @submit.prevent>
        <button @click="googleLogin()" class="btn btn-primary btn-white w-100"><img style="max-height: 24px" class="mr-2" src="@/assets/images/google.png" alt="Login Google" /> Fazer login com o Google</button>
      </form>
    </card>
  </div>
</template>
<script>
import { setInterval, clearInterval } from 'timers';
import api from '@/api.js';

export default {
  components: {},
  data() {
    return {
      email: '',
      password: '',
    };
  },
  methods: {
    googleLogin: async function () {
      const apiURL = this.getUrl();
      const googleWindow = window.open(apiURL + '/sessions/google', '', 'width=600, height=600, scrollbars=no, resizable=no, status=no, location=no, toolbar=no, menubar=no');
      this.windowWatcher(googleWindow);
    },
    getUrl() {
      return process.env.VUE_APP_BACKEND_URL;
    },
    windowWatcher(window) {
      const watcher = setInterval(async () => {
        const token = localStorage.getItem('auth');
        if (window.closed) {
          if (token && token.length > 0) {
            clearInterval(watcher);
            if (this.verifyAuthorizationHeader) api.defaults.headers.common.Authorization = `Bearer ${token}`;
            this.$router.push({ name: 'marcas' });
          }
        }
      }, 1000);
    },
    verifyAuthorizationHeader() {
      const existsAuthorizationHeader = !!api.defaults.headers.common.Authorization;
      const bearerTokenIsNull = api.defaults.headers.common.Authorization.split(' ')[1] === 'null';
      return !existsAuthorizationHeader || bearerTokenIsNull;
    },
  },
};
</script>
<style>
.login__separator {
  width: 100%;
  background-color: #ffffff;
}
.btn-white {
  background: #fff;
  color: #27293d;
  padding-left: 0;
  padding-right: 0;
}
</style>
